module.exports = __webpack_public_path__ + "media/Seher nach Rauch.9d1be817.mp3";